import React, { Component } from 'react';
import { Box, Button, CircularProgress, IconButton, Modal, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { Colors } from '../../../../Styles/Colors';
import ShowComponents from '../Common/ShowComponent';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import AddIcon from "@material-ui/icons/AddOutlined";
import SprayIcon from "@material-ui/icons/BlurCircular";
import UndoIcon from "@material-ui/icons/UndoOutlined";
import RedoIcon from "@material-ui/icons/RedoOutlined";
import CreateIcon from "@material-ui/icons/Create";
import LineIcon from "@material-ui/icons/BorderColor";
import RectIcon from "@material-ui/icons/CropLandscape";
import CircleIcon from "@material-ui/icons/RadioButtonUnchecked";
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { qDoctorPatientId, qDoctorAppointmentId } from '../../../../Utility/Services/DoctorPatientQueryIds';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RemoveIcon from '@mui/icons-material/Remove';
import { fabric } from "fabric";

const styles = {
    control: { width: "24px", height: "24px" },
    control_space_1: { width: "24px" },
};

let sketchDrawing = null;

export default class DocDrawingAreaLeft extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lineColor: "#000000",
            fillColor: "red",
            backgroundColor: "#FFF",
            appointmentId: this.props.appointmentId,
            patientId: this.props.PatientData?.patient_id,
            examinePopup: false,
            tool: null,
            isLoader: false,
            isRedo: false,
            isUndo: false,
            drawingImageUrl: '',
            drawingImageKey: '',
        };
        this.undoStack = [];
        this.redoStack = [];
    }

    apiCalls = () => {
        this.getDrawingAreaData();
    };

    componentDidUpdate = (prevProps) => {
        if (this.props !== prevProps && this.props.examinePopup && this.state.examinePopup !== this.props.examinePopup) {
            this.setState({ examinePopup: true }, () => this.getDrawingAreaData());
        }
    }

    componentWillUnmount() {
        if (this._containerRetryTimeout) clearTimeout(this._containerRetryTimeout);
        if (this._getRetryTimeout) clearTimeout(this._getRetryTimeout);
    }

    resizeCanvas = () => {
        if (!sketchDrawing) return;
        const canvasContainer = document.getElementById("drawingAreaCanvasContainer");
        if (!canvasContainer) return;
        sketchDrawing.setWidth(canvasContainer.clientWidth);
        sketchDrawing.setHeight(canvasContainer.clientHeight);
        sketchDrawing.renderAll();
    };

    setCanvasEmpty = () => {
        try {
            const canvasContainer = document.getElementById("drawingAreaCanvasContainer");
            if (!canvasContainer) return false;
            const w = canvasContainer.clientWidth;
            const h = canvasContainer.clientHeight;
            if (w <= 0 || h <= 0) return false;
            if (sketchDrawing) {
                sketchDrawing.dispose();
                sketchDrawing = null;
            }
            sketchDrawing = new fabric.Canvas("DrawingAreaCanvas", {
                backgroundColor: "#ffffff",
                width: w,
                height: h
            });
            this.saveState();
            sketchDrawing.on('object:added', this.saveState);
            sketchDrawing.on('object:modified', this.saveState);
            sketchDrawing.on('object:removed', this.saveState);
            window.removeEventListener("resize", this.resizeCanvas);
            window.addEventListener("resize", this.resizeCanvas);
            return true;
        } catch (e) {
            this.errorMessage(e.message);
            return false;
        }
    };

    ensureCanvasReadyThen = (onReady, retryCount = 0) => {
        const maxRetries = 30;
        const container = document.getElementById("drawingAreaCanvasContainer");
        if (container && container.clientWidth > 0 && container.clientHeight > 0) {
            if (this.setCanvasEmpty()) {
                onReady();
                return;
            }
        }
        if (retryCount < maxRetries) {
            this._containerRetryTimeout = setTimeout(() => this.ensureCanvasReadyThen(onReady, retryCount + 1), 100);
        } else {
            this.setState({ isLoader: false });
            onReady();
        }
    };

    setCanvasBackgroundImage = (imageUrl) => {
        if (!sketchDrawing || !imageUrl) return;
        fabric.Image.fromURL(imageUrl, (img) => {
            if (!img) return;
            img.set({ crossOrigin: 'anonymous' });
            const w = sketchDrawing.getWidth();
            const h = sketchDrawing.getHeight();
            const imgW = img.get('width') || img._element?.naturalWidth;
            const imgH = img.get('height') || img._element?.naturalHeight;
            if (imgW && imgH) {
                const scale = Math.min(w / imgW, h / imgH);
                img.set({ scaleX: scale, scaleY: scale, originX: 'left', originY: 'top', left: 0, top: 0 });
            }
            sketchDrawing.setBackgroundImage(img, sketchDrawing.renderAll.bind(sketchDrawing));
            this.saveState();
        }, { crossOrigin: 'anonymous' });
    };

    /**
     * ENT-style flow: create canvas with background image in one go (container must exist).
     * Retries until container has dimensions, then creates canvas and sets image.
     */
    setCanvasWithImage = (imageUrl, retryCount = 0) => {
        const maxRetries = 25;
        const canvasContainer = document.getElementById("drawingAreaCanvasContainer");
        if (!canvasContainer || canvasContainer.clientWidth <= 0 || canvasContainer.clientHeight <= 0) {
            if (retryCount < maxRetries) {
                this._containerRetryTimeout = setTimeout(() => this.setCanvasWithImage(imageUrl, retryCount + 1), 80);
                return;
            }
            this.setState({ isLoader: false });
            return;
        }
        try {
            const w = canvasContainer.clientWidth;
            const h = canvasContainer.clientHeight;
            if (sketchDrawing) {
                sketchDrawing.dispose();
                sketchDrawing = null;
            }
            sketchDrawing = new fabric.Canvas("DrawingAreaCanvas", {
                backgroundColor: "#ffffff",
                width: w,
                height: h
            });
            window.removeEventListener("resize", this.resizeCanvas);
            window.addEventListener("resize", this.resizeCanvas);
            this.saveState();
            sketchDrawing.on('object:added', this.saveState);
            sketchDrawing.on('object:modified', this.saveState);
            sketchDrawing.on('object:removed', this.saveState);

            if (imageUrl) {
                fabric.Image.fromURL(imageUrl, (img) => {
                    if (!img || !sketchDrawing) return;
                    img.set({ crossOrigin: 'anonymous' });
                    const imgW = img.get('width') || img._element?.naturalWidth;
                    const imgH = img.get('height') || img._element?.naturalHeight;
                    if (imgW && imgH) {
                        const scale = Math.min(w / imgW, h / imgH);
                        img.set({ scaleX: scale, scaleY: scale, originX: 'left', originY: 'top', left: 0, top: 0 });
                    }
                    sketchDrawing.setBackgroundImage(img, sketchDrawing.renderAll.bind(sketchDrawing));
                    this.saveState();
                    this.setState({ isLoader: false });
                }, { crossOrigin: 'anonymous' });
            } else {
                this.setState({ isLoader: false });
            }
        } catch (e) {
            this.errorMessage(e.message);
            this.setState({ isLoader: false });
        }
    };

    /**
     * Fetch AWS URL for drawing_image_key then create canvas with that image (like ENT setBackgroundImage + setCanvasBgImage).
     */
    setBackgroundImageForPopup = (drawing_image_key) => {
        if (!drawing_image_key) {
            this.ensureCanvasReadyThen(() => {});
            return;
        }
        RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + '?doc_key=' + encodeURIComponent(drawing_image_key))
            .then((res) => {
                const payload = res?.data;
                const imageUrl = (payload && typeof payload.data === 'string') ? payload.data : (payload?.data?.data ?? payload?.data);
                if (imageUrl) {
                    this.setCanvasWithImage(imageUrl);
                } else {
                    this.setState({ isLoader: false });
                    this.ensureCanvasReadyThen(() => {});
                }
            })
            .catch(() => {
                this.setState({ isLoader: false });
                this.ensureCanvasReadyThen(() => {});
            });
    };

    fetchDrawingImageUrl = (drawing_image_key) => {
        if (!drawing_image_key) return;
        RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + '?doc_key=' + encodeURIComponent(drawing_image_key))
            .then((response) => {
                const payload = response?.data;
                const url = (payload && typeof payload.data === 'string') ? payload.data : (payload?.data?.data ?? payload?.data);
                if (url) {
                    this.setState({ drawingImageUrl: url, drawingImageKey: drawing_image_key });
                }
            })
            .catch(() => {});
    };

    getDrawingAreaData = (isRetry = false) => {
        try {
            if (!isRetry) this.setState({ isLoader: true });
            const sectionKey = this.props.drawingAreaKey || this.props.custom_name || '';
            const url = Serviceurls.SARAS_DOC_DRAWING_AREA_GET + `?appointment_id=${qDoctorAppointmentId(this.state.appointmentId)}&patient_id=${qDoctorPatientId(this.state.patientId)}` + (sectionKey ? `&section_key=${encodeURIComponent(sectionKey)}` : '');

            RestAPIService.getAll(url)
                .then((response) => {
                    const raw = response?.data;
                    const data = (raw && raw.data !== undefined && raw.data !== null ? raw.data : raw) || {};
                    const drawing_image_key = data.drawing_image_key || '';
                    const hasPayload = data && (drawing_image_key || data.appointment_id != null);
                    const statusOk = raw?.status === 'success' || hasPayload;

                    if (statusOk && hasPayload) {
                        const inPopupWithImage = this.state.examinePopup && !!drawing_image_key;
                        if (!inPopupWithImage) this.setState({ isLoader: false });

                        if (drawing_image_key) {
                            this.fetchDrawingImageUrl(drawing_image_key);
                        } else {
                            this.setState({ drawingImageUrl: '', drawingImageKey: '' });
                        }

                        if (this.state.examinePopup) {
                            if (drawing_image_key) {
                                this.setBackgroundImageForPopup(drawing_image_key);
                            } else {
                                this.setState({ isLoader: false });
                                this.ensureCanvasReadyThen(() => {});
                            }
                        }
                    } else {
                        this.setState({ isLoader: false });
                        if (this.state.examinePopup) this.ensureCanvasReadyThen(() => {});
                    }
                })
                .catch((error) => {
                    if (!isRetry) {
                        this._getRetryTimeout = setTimeout(() => this.getDrawingAreaData(true), 800);
                        return;
                    }
                    if (error?.response?.data?.message) this.errorMessage(error.response.data.message);
                    else this.errorMessage(error.message || 'Failed to load drawing');
                    this.setState({ isLoader: false });
                    if (this.state.examinePopup) this.ensureCanvasReadyThen(() => {});
                });
        } catch (error) {
            this.setState({ isLoader: false });
            this.errorMessage(error.message);
            if (this.state.examinePopup) this.ensureCanvasReadyThen(() => {});
        }
    };

    errorMessage = (message) => {
        this.setState({ isErrorMsg: true, isErrorMsgText: message, isLoader: false });
    };

    successMessage = (message) => {
        this.setState({ successMsg: true, successMsgText: message, isLoader: false });
    };

    msgClose() {
        this.setState({ isErrorMsg: false, isErrorMsgText: '', successMsg: false, successMsgText: '' });
    }

    renderDrawingArea = (fromPopup = false) => {
        if (fromPopup) {
            return (
                <div id="drawingAreaCanvasContainer" style={{ height: '100%', width: '100%' }}>
                    <canvas id="DrawingAreaCanvas" />
                </div>
            );
        }
        if (this.state.drawingImageUrl) {
            return (
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    <img src={this.state.drawingImageUrl} alt="Drawing" style={{ width: '100%', height: 'auto', objectFit: 'contain', maxHeight: '400px' }} />
                </Box>
            );
        }
        return (
            <Box sx={{ width: '100%', minHeight: '200px', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: Colors.Background }}>
                <Typography variant="body2" color="text.secondary">Drawing area — Click Examine to Draw</Typography>
            </Box>
        );
    };

    dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(",")[1]);
        const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
        return new Blob([ab], { type: mimeString });
    };

    clear = () => {
        if (!sketchDrawing) return;
        sketchDrawing.off("object:added");
        sketchDrawing.off("object:modified");
        sketchDrawing.off("object:removed");
        const w = sketchDrawing.getWidth();
        const h = sketchDrawing.getHeight();
        sketchDrawing.clear();
        this.undoStack = [];
        this.redoStack = [];
        this.tempShape = null;
        sketchDrawing.setWidth(w);
        sketchDrawing.setHeight(h);
        sketchDrawing.setBackgroundColor("#ffffff");
        sketchDrawing.renderAll();
        this.saveState();
        sketchDrawing.on("object:added", this.saveState);
        sketchDrawing.on("object:modified", this.saveState);
        sketchDrawing.on("object:removed", this.saveState);
        this.setState({
            tool: "", text: "", lineColor: "#000000",
            isRedo: false, isUndo: false,
        });
    };

    changeColor = (color) => {
        this.setState({ lineColor: color }, () => {
            if (sketchDrawing?.freeDrawingBrush) sketchDrawing.freeDrawingBrush.color = color;
        });
    };

    isCanvasEmpty = () => {
        if (!sketchDrawing) return true;
        const objects = sketchDrawing.getObjects();
        return !objects || objects.length === 0;
    };

    handleSave = () => {
        try {
            if (!sketchDrawing) return;
            if (this.isCanvasEmpty()) {
                this.errorMessage('Please draw something before saving.');
                return;
            }
            const sketchData = sketchDrawing.toDataURL();
            if (sketchData) {
                const data = new FormData();
                data.append('appointment_id', this.state.appointmentId);
                data.append('patient_id', this.state.patientId);
                data.append('image', this.dataURItoBlob(sketchData));
                data.append('image_json', JSON.stringify(sketchDrawing.toJSON()));
                data.append('notes', '');
                const sectionKey = this.props.drawingAreaKey || this.props.custom_name;
                if (sectionKey) data.append('section_key', sectionKey);

                RestAPIService.create(data, Serviceurls.SARAS_DOC_DRAWING_AREA_GET)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.successMessage(response?.data?.message);
                            this.props.isDataSaved();
                            this.clear();
                            this.setState({ examinePopup: false }, () => this.getDrawingAreaData());
                        }
                    })
                    .catch((error) => {
                        this.errorMessage(error.message);
                        this.props.isDataSaved();
                        this.setState({ examinePopup: false });
                    });
            }
        } catch (e) {
            this.errorMessage(e.message);
            this.props.isDataSaved();
            this.setState({ examinePopup: false });
        }
    };

    handleArrow = (x1, y1, x2, y2, direction) => {
        sketchDrawing.isDrawingMode = false;
        const line = new fabric.Line([x1, y1, x2, y2], { fill: this.state.lineColor, stroke: this.state.lineColor, strokeWidth: 2 });
        const arrowHead = new fabric.Triangle({ fill: this.state.lineColor, width: 15, height: 20, left: x2, top: y2, originX: "center", originY: "center" });
        if (direction === "up") arrowHead.set({ angle: 0 });
        else if (direction === "down") arrowHead.set({ angle: 180 });
        else if (direction === "left") arrowHead.set({ angle: -90 });
        else if (direction === "right") arrowHead.set({ angle: 90 });
        sketchDrawing.add(new fabric.Group([line, arrowHead]));
    };

    saveState = () => {
        if (!sketchDrawing) return;
        const currentState = JSON.stringify(sketchDrawing.toJSON());
        if (!this.undoStack?.includes(currentState) && !this.state.isUndo && !this.state.isRedo) this.undoStack.push(currentState);
    };

    undo = () => {
        if (this.undoStack.length <= 1) return;
        this.redoStack.unshift(this.undoStack.pop());
        this.loadState(this.undoStack[this.undoStack.length - 1]);
    };

    redo = () => {
        if (this.redoStack.length === 0) return;
        this.undoStack.push(this.redoStack.shift());
        this.loadState(this.undoStack[this.undoStack.length - 1]);
    };

    loadState = (state) => {
        if (state && sketchDrawing) {
            sketchDrawing.clear();
            sketchDrawing.loadFromJSON(state, () => {
                sketchDrawing.renderAll();
                this.setState({ isUndo: false, isRedo: false });
            });
        }
    };

    setTool = (tool) => {
        if (!sketchDrawing) return;
        sketchDrawing.isDrawingMode = false;
        this.setState({ tool }, () => {
            switch (tool) {
                case "spray":
                    sketchDrawing.freeDrawingBrush = new fabric.SprayBrush(sketchDrawing);
                    sketchDrawing.isDrawingMode = true;
                    sketchDrawing.freeDrawingBrush.width = 10;
                    this.changeColor("#000000");
                    break;
                case "pencil":
                    sketchDrawing.isDrawingMode = true;
                    sketchDrawing.freeDrawingBrush = new fabric.PencilBrush(sketchDrawing);
                    sketchDrawing.freeDrawingBrush.width = 3;
                    this.changeColor("#000000");
                    break;
                case "brush":
                    sketchDrawing.isDrawingMode = true;
                    sketchDrawing.freeDrawingBrush = new fabric.PencilBrush(sketchDrawing);
                    sketchDrawing.freeDrawingBrush.width = 10;
                    this.changeColor("#000000");
                    break;
                case "eraser":
                    sketchDrawing.isDrawingMode = true;
                    sketchDrawing.freeDrawingBrush = new fabric.PencilBrush(sketchDrawing);
                    sketchDrawing.freeDrawingBrush.width = 10;
                    this.changeColor("#FFFFFF");
                    break;
                case "line":
                    sketchDrawing.selection = false;
                    sketchDrawing.add(new fabric.Line([50, 100, 300, 100], { stroke: this.state.lineColor, strokeWidth: 5, selectable: true }));
                    break;
                case "rectangle":
                    sketchDrawing.add(new fabric.Rect({ left: 260, top: 220, width: 60, height: 60, fill: 'transparent', stroke: this.state.lineColor, strokeWidth: 2 }));
                    break;
                case "circle":
                    sketchDrawing.add(new fabric.Circle({ left: 240, top: 200, radius: 50, fill: 'transparent', stroke: this.state.lineColor, strokeWidth: 2 }));
                    break;
                case "text":
                    sketchDrawing.add(new fabric.Text(this.state.text || '', { left: 270, top: 240, fontFamily: 'Arial', fontSize: 14, fill: this.state.lineColor }));
                    this.setState({ text: '' });
                    break;
                case "plus":
                    sketchDrawing.add(new fabric.Text("+", { left: 500, top: 150, fontSize: 50, fill: this.state.lineColor, fontWeight: "bold", selectable: true, hasControls: true, lockUniScaling: false }));
                    sketchDrawing.renderAll();
                    break;
                case "minus":
                    sketchDrawing.add(new fabric.Text("-", { left: 550, top: 150, fontSize: 50, fill: this.state.lineColor, fontWeight: "bold", selectable: true, hasControls: true, lockUniScaling: false }));
                    sketchDrawing.renderAll();
                    break;
                default:
                    break;
            }
        });
    };

    renderExaminePopup = () => {
        return (
            <Modal open={this.state.examinePopup} sx={{ outline: "none" }}>
                <Paper elevation={3} id="emedhub_popup_mainBox" sx={{ width: '95dvw', height: '100dvh', overflowY: 'auto', outline: "none" }}>
                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'1px solid lightgray'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600}>{this.props.custom_name || "Drawing area"}</Typography>
                        <Button
                            className="Common_Btn_Min_Width"
                            onClick={() => { this.props.isDataSaved(); this.setState({ examinePopup: false }); this.clear(); }}
                        >
                            <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                        </Button>
                    </Box>
                    <Box component={'div'} display={'flex'} width={"100%"} height={"90%"}>
                        <Box width={"70%"} sx={{ border: '1px solid #ccc', boxSizing: 'border-box' }}>{this.renderDrawingArea(true)}</Box>
                        <Box width={"30%"}>
                            <Box sx={{ height: '100%', display: 'flex', flexDirection: "column", gap: '1vw', justifyContent: 'space-between', p: '0.5vw' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1.5vw', height: '100%', justifyContent: 'space-between' }}>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "0.5vw", flexDirection: "column", justifyContent: "center", backgroundColor: Colors.Background }}>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: '1vw' }}>
                                            <Tooltip placement="top" title={'Spray'}><IconButton size='small' color="primary" onClick={() => this.setTool("spray")}><SprayIcon style={styles.control} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Pencil"}><IconButton size='small' color="primary" onClick={() => this.setTool("pencil")}><CreateIcon style={styles.control} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Line Pencil"}><IconButton size='small' sx={{ marginTop: "0.5vw" }} color="primary" onClick={() => this.setTool("line")}><LineIcon style={styles.control} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Rectangle"}><IconButton size='small' color="primary" onClick={() => this.setTool("rectangle")}><RectIcon style={styles.control} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Brush"}><IconButton size='small' color="primary" style={{ marginLeft: "-0.5vw" }} onClick={() => this.setTool("brush")}><Box component={'img'} src={ImagePaths.Brush.default} height={'1.4vw'} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Circle"}><IconButton size='small' color="primary" onClick={() => this.setTool("circle")}><CircleIcon style={styles.control} /></IconButton></Tooltip>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: '1vw' }}>
                                            <Tooltip placement="top" title={"Plus"}><IconButton size='small' color="primary" onClick={() => this.setTool("plus")}><AddIcon style={styles.control} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Minus"}><IconButton size='small' color="primary" onClick={() => this.setTool("minus")}><RemoveIcon style={styles.control} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Arrow Left"}><IconButton size='small' color="primary" style={{ marginLeft: "-0.5vw" }} onClick={() => this.handleArrow(350, 200, 250, 200, "left")}><Box component={'img'} src={ImagePaths.ArrowLeft.default} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Arrow Right"}><IconButton size='small' color="primary" style={{ marginLeft: "-0.5vw" }} onClick={() => this.handleArrow(50, 200, 150, 200, "right")}><Box component={'img'} src={ImagePaths.ArrowRight.default} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Arrow Down"}><IconButton color="primary" style={{ marginLeft: "-0.5vw" }} onClick={() => this.handleArrow(200, 50, 200, 150, "down")}><Box component={'img'} src={ImagePaths.ArrowDown.default} /></IconButton></Tooltip>
                                            <Tooltip placement="top" title={"Arrow Up"}><IconButton size='small' color="primary" style={{ marginLeft: "-0.5vw" }} onClick={() => this.handleArrow(200, 350, 200, 250, "up")}><Box component={'img'} src={ImagePaths.ArrowUp.default} /></IconButton></Tooltip>
                                        </div>
                                        <div style={{ display: 'flex', margin: '0.5vw' }}>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#000000" ? "1px solid black" : null }} onClick={() => this.changeColor("#000000")}><Box component={'img'} src={ImagePaths.Black.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#F19C38" ? "1px solid black" : null }} onClick={() => this.changeColor("#F19C38")}><Box component={'img'} src={ImagePaths.Orange.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#4A95EC" ? "1px solid black" : null }} onClick={() => this.changeColor("#4A95EC")}><Box component={'img'} src={ImagePaths.Blue.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#67AC5B" ? "1px solid black" : null }} onClick={() => this.changeColor("#67AC5B")}><Box component={'img'} src={ImagePaths.Green.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#E15241" ? "1px solid black" : null }} onClick={() => this.changeColor("#E15241")}><Box component={'img'} src={ImagePaths.Red.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#74574A" ? "1px solid black" : null }} onClick={() => this.changeColor("#74574A")}><Box component={'img'} src={ImagePaths.Brown.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                            <Button className='Common_Btn_Min_Width' style={{ border: this.state.lineColor === "#FFFFFF" ? "1px solid black" : null }} onClick={() => this.changeColor("#FFFFFF")}><Box component={'img'} src={ImagePaths.White.default} height={'1.5vw'} width={'1.5vw'} /></Button>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "center" }}>
                                            <Tooltip placement="top" title={"Eraser"}><Button size='small' color="primary" onClick={() => this.setTool("eraser")}><Box component={'img'} src={ImagePaths.Eraser.default} height={'1.2vw'} width={'1.2vw'} /></Button></Tooltip>
                                            <Tooltip placement="top" title={"Undo"}><Button size='small' color="primary" disabled={(this.undoStack?.length <= 1 || this.state.isUndo)} onClick={() => this.setState({ isUndo: true }, () => this.undo())}><UndoIcon style={styles.control} /></Button></Tooltip>
                                            <Tooltip placement="top" title={"Redo"}><Button size='small' color="primary" disabled={(this.redoStack?.length === 0 || this.state.isRedo)} onClick={() => this.setState({ isRedo: true }, () => this.redo())}><RedoIcon style={styles.control} /></Button></Tooltip>
                                            <div style={{ justifyContent: "center" }}>
                                                <TextField id="standard-basic" variant="standard" value={this.state.text} onChange={(e) => this.setState({ text: e.target.value })} />
                                                <div style={{ fontSize: '0.8vw', color: "grey", marginTop: 5 }}>Enter text to add</div>
                                            </div>
                                            <Tooltip placement="top" title={"Add Text"}><Button size='small' color="primary" onClick={() => this.setTool("text")}><AddIcon style={styles.control} /></Button></Tooltip>
                                        </div>
                                    </div>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: '1vw' }}>
                                    <Button size='small' variant='outlined' onClick={() => this.clear()}>Clear</Button>
                                    <Button size='small' variant='contained' onClick={() => this.handleSave()}>Save</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Modal>
        );
    };

    render() {
        return (
            <ShowComponents onIntersection={this.apiCalls.bind(this)}>
                {this.state.isLoader ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '2vw' }}><CircularProgress color="primary" /></Box>
                ) : (
                    <Box>
                        <Box p="0.5vw">{this.renderDrawingArea(false)}</Box>
                    </Box>
                )}
                {this.renderExaminePopup()}
                {this.state.isErrorMsg && <ToastMsg severity="error" msg={this.state.isErrorMsgText} msgPop={this.msgClose.bind(this)} />}
                {this.state.successMsg && <ToastMsg severity="success" msg={this.state.successMsgText} msgPop={this.msgClose.bind(this)} />}
            </ShowComponents>
        );
    }
}
